<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.6055 11.694L12.6055 12.694C11.0055 14.294 8.50547 14.294 7.00547 12.694L1.30547 7.09401C-0.294531 5.49401 -0.294531 2.99401 1.30547 1.39401L2.30547 0.394013C2.70547 -0.00598744 3.40547 -0.00598744 3.80547 0.494013L5.30547 2.39401C5.60547 2.79401 5.60547 3.39401 5.20547 3.69401L3.90547 5.09401L8.90547 10.094L10.3055 8.69401C10.7055 8.29401 11.2055 8.29401 11.6055 8.59401L13.5055 10.094C14.0055 10.594 14.0055 11.294 13.6055 11.694Z"
      fill="currentColor"
    />
  </svg>
</template>
